import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const getCustomerByFinancialAccountId = async financialAccountId => {
  const response = await fetchWithAuthorization({
    path: `${END_POINTS.REWARDS_GRANT.GET_CUSTOMER_BY_FINANCIAL_ACCOUNT_ID}${financialAccountId}`,
    method: 'GET',
  })
  // TODO: Move to fetchWithAuthorization
  if (response.error) {
    const error = new Error(response.message)
    error.status = response.status
    throw error
  }
  return response
}

export const createGoodwillAdjustment = async ({ customerId, points, comments }) => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_GRANT.CREATE_GOODWILL_ADJUSTMENT,
    method: 'POST',
    body: JSON.stringify({ customerId, points, comments }),
  })
  // TODO: Move to fetchWithAuthorization
  if (response.errors) {
    const error = new Error(response.errors[0].message)
    error.status = response.errors[0].status
    throw error
  }
  return response
}

export const createLoanLeaseAdjustment = async ({ customerId, points, comments, correctedMonth }) => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_GRANT.CREATE_LOAN_LEASE_ADJUSTMENT,
    method: 'POST',
    body: JSON.stringify({ customerId, points, comments, correctedMonth }),
  })
  // TODO: Move to fetchWithAuthorization
  if (response.errors) {
    const error = new Error(response.errors[0].message)
    error.status = response.errors[0].status
    throw error
  }
  return response
}

export const getManualAdjustments = async (page = 1, perPage = 10, ledgerTypes = []) => {
  // Call the function to get the base URL with page and perPage
  let path = END_POINTS.REWARDS_GRANT.GET_MANUAL_ADJUSTMENTS(page, perPage)

  // Append ledgerTypes if provided (using & since the URL already has query params)
  if (ledgerTypes && ledgerTypes.length > 0) {
    path += `&ledgerTypes=${ledgerTypes.join(',')}`
  }

  const response = await fetchWithAuthorization({
    path,
    method: 'GET',
  })
  return response
}

export const getDmlScripts = async () => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_GRANT.GET_DML_SCRIPTS,
    method: 'GET',
  })
  return response
}

export const runDmlScript = async ({ scriptName, dryRun = false }) => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_GRANT.RUN_DML_SCRIPT,
    method: 'POST',
    body: JSON.stringify({ scriptName, dryRun }),
  })
  // TODO: Move to fetchWithAuthorization
  if (response.errors) {
    const error = new Error(response.errors[0].message)
    error.status = response.errors[0].status
    throw error
  }
  return response
}
